import { transformToBasicPerson } from '@/entities/Person/PersonTransformers'
import { BasicUser } from '@/entities/User/User'
import { UserResource } from '@/models'

export const transformLegacyBasicUserToBasicUser = (user: UserResource): BasicUser => ({
    id: user.id,
    employeeNumber: user.employeeNumber,
    person: transformToBasicPerson(user.firstname, user.lastname, user.affix || undefined),
    plannedHoursInWeek: user.plannedHoursInWeek || 0,
    plannedConceptHoursInWeek: user.plannedConceptHoursInWeek || 0,
})
